import { useAuth } from "@airborne/react-admin";
import * as React from "react";
import { FC, useState } from "react";
import { BooleanInput, Filter, FilterProps, SelectInput, TextInput } from "react-admin";
import { useAppDataProvider } from "../../../../dataprovider";
import { GetAlternatePnStatus } from "../../../../../src/Enums/AlternatePnStatus";

const DashboardFilter: FC<Omit<FilterProps, "children">> = props => {
  // const [acRegList, setAcRegList] = useState([] as any)
  // const [customerList, setCustomerList] = useState([] as any)
  const [statusList, setStatusList] = useState([] as any);
  const dataProvider = useAppDataProvider();
  const { user } = useAuth();

  React.useEffect(() => {
    // GetAircraftList()
    // GetCustomerList()
    GetStatusList();
  }, []);

  const GetStatusList = async () => {
    dataProvider
      .getList("PbhRequestStatusInfos", {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "id", order: "DESC" },
        filter: {},
      })
      .then(response => {
        setStatusList([]);
        if (response?.data?.length > 0) {
          let data = response.data;
          setStatusList(data);
        }
      })
      .catch(error => {
        setStatusList([]);
        console.log(error);
      });
  };

  // const CreateUri = (ownerCode?: string): string => {
  //     let uri = 'cdmaircraft';
  //     if (ownerCode) {
  //         uri = 'cdmaircraft/' + ownerCode;
  //     } else {
  //         if (user?.isCustomer) {
  //             uri = 'cdmaircraft/' + user?.ownerCode;
  //         }
  //     }

  //     return uri;
  // }

  // const GetAircraftList = async (ownerCode?: string) => {
  //     dataProvider
  //         .getList(CreateUri(ownerCode), {
  //             pagination: { page: 1, perPage: 9999 },
  //             sort: { field: 'id', order: 'DESC' },
  //             filter: {}
  //         })
  //         .then((response) => {
  //             let dataLength: number = response.data.length
  //             setAcRegList([])
  //             if (dataLength > 0) {
  //                 let data = response.data
  //                 setAcRegList(data)
  //             }
  //         })
  //         .catch((error) => {
  //             console.log(error)
  //         })
  // }

  // const GetCustomerList = async () => {
  //     dataProvider
  //         .getList('customers/', {
  //             pagination: { page: 1, perPage: 9999 },
  //             sort: { field: 'id', order: 'DESC' },
  //             filter: {}
  //         })
  //         .then((response) => {
  //             let dataLength: number = response.data.length
  //             setCustomerList([])
  //             if (dataLength > 0) {
  //                 let data = response.data
  //                 setCustomerList(data)
  //             }
  //         })
  //         .catch((error) => {
  //             console.log(error)
  //         })
  // }

  // const ownerHandleChange = (e) => {
  //     let ownerCode = e?.target?.value
  //     GetAircraftList(ownerCode);
  // }

  return (
    <Filter {...props}>
      <TextInput label="Ref No" source="refNo__contains" alwaysOn />
      <TextInput label="PN" source="pn__contains" alwaysOn />
      <TextInput label="PN Description" source="pnDescription__contains" alwaysOn />
      <TextInput label="Destination" source="airportCode__contains" alwaysOn />
      {/* {!user?.isCustomer && <SelectInput source="customerCode__eq" label="Customer" optionText="customerName" optionValue="customerCode" choices={customerList} onChange={ownerHandleChange} fullWidth alwaysOn />} */}
      {!user?.isCustomer && <TextInput label="Customer" source="customerName__contains" alwaysOn />}
      <TextInput label="AC" source="acRegistration__contains" alwaysOn />
      <TextInput label="Customer PO" source="customerPo__contains" alwaysOn />
      <TextInput label="Requirement Category" source="requirementCategoryText__contains" alwaysOn />
      <SelectInput
        source="alternatePnStatus__eq"
        label="Alternate Pn Status"
        optionText="Description"
        optionValue="Value"
        choices={GetAlternatePnStatus}
        fullWidth
        alwaysOn
      />
      <SelectInput
        source="requestStatus__eq"
        label="Request Status"
        optionText="displayName"
        optionValue="requestStatus"
        choices={statusList}
        fullWidth
        alwaysOn
      />
      {!user?.isCustomer && <BooleanInput label="Is Pool Scope" source="isPool__eq" alwaysOn />}
    </Filter>
  );
};
export default DashboardFilter;
